module.exports = __webpack_public_path__ + "img/rep-nick.b3dcf61b.png";